<template>
  <span>{{ displayName }}</span>
</template>
<script>
export default {
  props: ["item"],
  computed: {
    displayName() {
      //fall back to the file name for instructions without a title
      return this.item?.title || this.item?.name;
    },
  },
};
</script>
